// @flow
import { useDispatch, useSelector } from 'react-redux';

function DeleteLink () {
  const dispatch = useDispatch();
  const onClearClick = React.useCallback(
    () => {
      dispatch({
        type: 'CLEAR_DYOR_SETTING',
        callback: () => {
          dispatch({
            type: 'FETCH_INITIAL_DIAMONDS'
          });
        }
      });
    },
    [dispatch]
  );

  return (
    <a href="#" onClick={onClearClick}>
      delete
    </a>
  );
}

export default function SettingCompatibility () {
  const selectedShapes = useSelector(
    (state) => state.diamondSearchFilters.shape
  );
  const isDyorSettingChosen = useSelector(
    (state) => !!state.ringBuilder.setting.sku
  );
  const compatibleShapes = useSelector(
    (state) =>
      (state.ringBuilder.setting.data &&
        state.ringBuilder.setting.data.compatible_diamond_shapes) ||
      []
  );

  if (!isDyorSettingChosen) return null;

  const isSettingCompatible =
    compatibleShapes.filter((compatible) => selectedShapes.includes(compatible))
      .length > 0;

  if (isSettingCompatible) return null;

  return (
    <div className="flash-message alert">
      This diamond shape is not compatible with your chosen setting. Please{' '}
      <DeleteLink /> your setting or choose a different diamond shape.
    </div>
  );
}
